import axios from "axios";
import { apiUrl } from "../config/environment";
import { BroadcastGroupListResponse, BroadcastListResponse } from "../interfaces/broadcast";
import { getAuthHeaders } from "../utils/authUtils";

const api: string = `${apiUrl}/api/broadcast-groups`;
const legacyApi: string = `${apiUrl}/api/broadcasts`;

export async function listBroadcastGroups(params: {
  page?: number;
  limit?: number;
  type?: "WTB" | "WTS";
  status?: string;
  sent?: boolean;
  search?: string;
  sort?: string; // e.g., "createdAt:desc"
}): Promise<BroadcastGroupListResponse> {
  const { data } = await axios.get(api, {
    params,
    ...getAuthHeaders(),
  });
  return data;
}

// Legacy function for backward compatibility
export async function listBroadcasts(params: {
  page?: number;
  limit?: number;
  type?: "WTB" | "WTS";
  status?: string;
  sent?: boolean;
  search?: string;
  sort?: string; // e.g., "createdAt:desc"
}): Promise<BroadcastListResponse> {
  try {
    // Try new endpoint first
    const { data } = await axios.get(api, {
      params,
      ...getAuthHeaders(),
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      // Fallback to legacy endpoint
      const { data } = await axios.get(legacyApi, {
        params,
        ...getAuthHeaders(),
      });
      return data;
    }
    throw error;
  }
}

export async function listBroadcastGroupsRaw(
  params: {
    page?: number;
    limit?: number;
    type?: "WTB" | "WTS";
    status?: string;
    sort?: string; // e.g. 'createdAt:desc'
  } = {},
): Promise<BroadcastGroupListResponse> {
  const { data } = await axios.get(api, {
    params: { sort: "createdAt:desc", ...params },
    ...getAuthHeaders(),
  });
  return data;
}

// Legacy function for backward compatibility
export async function listBroadcastsRaw(
  params: {
    page?: number;
    limit?: number;
    type?: "WTB" | "WTS";
    status?: string;
    sort?: string; // e.g. 'createdAt:desc'
  } = {},
): Promise<BroadcastListResponse> {
  try {
    // Try new endpoint first
    const { data } = await axios.get(api, {
      params: { sort: "createdAt:desc", ...params },
      ...getAuthHeaders(),
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      // Fallback to legacy endpoint
      const { data } = await axios.get(legacyApi, {
        params: { sort: "createdAt:desc", ...params },
        ...getAuthHeaders(),
      });
      return data;
    }
    throw error;
  }
}

// Fetch all broadcasts from other users with user info populated
export async function listAllBroadcastsWithUsers(
  params: {
    page?: number;
    limit?: number;
    type?: "WTB" | "WTS";
    status?: string;
    search?: string;
    sellerId?: string; // [2025-01-12] Broadcast filter: Support filtering by sellerId
  } = {},
): Promise<BroadcastListResponse> {
  const { data } = await axios.get(`${api}/all`, {
    params,
    ...getAuthHeaders(),
  });
  return data;
}

// [2026-07-06] GUEST_ACCESS BR-09/10: masked "Latest broadcasts" feed for the guest dashboard.
// No auth headers (anonymous); server strips price + seller identity (BR-12).
export async function listPublicBroadcasts(
  params: { page?: number; limit?: number; type?: "WTB" | "WTS" } = {},
): Promise<BroadcastListResponse> {
  const { data } = await axios.get(`${apiUrl}/api/public/broadcasts`, { params });
  return data.data; // controller wraps in { success, data: { items, total, page, pages } }
}
